// Display-only tax wording. The storefront computes sales tax as $0 today (no
// tax rates exist) and Aldelo bills tax later, so a literal "$0.00" tax line
// would promise a total that billing will not honor. This module only decides
// how a zero is SHOWN; it never changes a stored or wire value, and any
// non-zero amount keeps the real-value path.

/** Shown in place of a $0 tax amount. */
export const TAX_AT_BILLING_VALUE = "Calculated at billing";

/** Order total label while tax is not yet included in the total. */
export const TOTAL_BEFORE_TAX_LABEL = "Total before tax";

/**
 * True only for a parseable, finite zero (number or decimal string). A missing
 * or unparseable value is NOT pending: it keeps whatever the caller rendered
 * before, so this never hides a data fault behind friendly wording.
 */
export function isTaxPending(
  amount: number | string | null | undefined,
): boolean {
  if (amount === null || amount === undefined) return false;
  if (typeof amount === "string" && amount.trim() === "") return false;
  const n = Number(amount);
  return Number.isFinite(n) && n === 0;
}
